import { getRequest } from '../../../shared/axiosRequest';
import { API_PATHS } from '../../../shared/apiConsts';
import { netbatchJobsActions } from '../../reducers/netbatchJobs/netbatchJobs';

export const openNBJobVNCDisplay = job => {
  return async dispatch => {
    try {
      const response = await getRequest(API_PATHS.GET_VNC_DISPLAY_DETAILS, {
        jobId: job.Jobid,
      });
      dispatch(
        netbatchJobsActions.setNBJobVNCDisplay({
          ...job,
          //   password: response[0].VNCServerPassword,
        })
      );
      dispatch(netbatchJobsActions.setShouldOpenWindow(job));
    } catch (error) {
      console.error(error);
    }
  };
};

export const setWindowOpened = job => {
  return async dispatch => {
    try {
      dispatch(
        netbatchJobsActions.setWindowOpened({
          ...job,
        })
      );
    } catch (error) {
      console.error(error);
    }
  };
};

export const setExternalWindow = (externalWindow, Jobid) => {
  return async dispatch => {
    try {
      dispatch(
        netbatchJobsActions.setExternalWindow({
          Jobid: Jobid,
          externalWindow: externalWindow,
        })
      );
    } catch (error) {
      console.error(error);
    }
  };
};

export const unsetExternalWindow = Jobid => {
  return async dispatch => {
    try {
      dispatch(
        netbatchJobsActions.unsetExternalWindow({
          Jobid: Jobid,
        })
      );
    } catch (error) {
      console.error(error);
    }
  };
};

export const removeJobFromState = Jobid => {
  return async dispatch => {
    try {
      dispatch(
        netbatchJobsActions.removeJobFromState({
          Jobid: Jobid,
        })
      );
    } catch (error) {
      console.error(error);
    }
  };
};
